module.exports = __webpack_public_path__ + "static/media/laborest-logo.38c43896.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/laborest-logo.png
// module id = 737
// module chunks = 0